export const gabrielaJaniszewska = {
    'meta': {
        'title': 'Psychoterapeuta Gabriela Janiszewska • Centrum COLLIGO',
        'description': 'Jestem psychologiem i psychoterapeutą pracującym w nurcie poznawczo-behawioralnym. Posiadam tytuł magistra psychologii, a także anglistyki.'
    },
    'url': {
        'address': '/torun/zespol/gabriela-janiszewska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/gabriela-janiszewska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeuta Gabriela Janiszewska • Centrum COLLIGO'
        }
    }
}